// firebaseConfig.js
import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  logEvent,
  setUserId,
  setUserProperties,
} from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAxZ40TRNPtq6fAWNY-kYExzDQfuak3P3s",
  authDomain: "aanya-49cc0.firebaseapp.com",
  projectId: "aanya-49cc0",
  storageBucket: "aanya-49cc0.firebasestorage.app",
  messagingSenderId: "170741017349",
  appId: "1:170741017349:web:d1a595f7328014b2db256c",
  measurementId: "G-QWFMTLTMVW",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics, logEvent, setUserId, setUserProperties };
